<template>
  <div class="symbol-keypad">
    <button v-for="item in appConfig.keypadSymbols" @click="emit('symbolSelected', item)" class="flex flex-1 items-center justify-center aspect-square text-2xl pt-1 bg-silver cursor-pointer transition-all hover:bg-conversion hover:text-white hover:scale-125">{{ item }}</button>
  </div>
</template>
<script setup>

const appConfig = useAppConfig();

const emit = defineEmits(['symbolSelected']);

</script>
<style lang="postcss">

.symbol-keypad {
  display: grid;
  gap: 4px;
  grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
  font-family: 'symbols';
}

</style>